import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import Router from 'vue-router'
// import VSoccerPage from '@/pages/vsoccer/VSoccerPage.vue'
import VGamesContainer from '@/pages/VGamesContainer.vue'
import StakeTable from '@/components/soccer/match/StakeTable.vue'
import OneMatch from '@/components/soccer/match/OneMatch.vue'
import MatchesSlide from '@/components/soccer/match/MatchesSlide.vue'

import StatisticsTotalGoals from '@/components/soccer/statistics/StatisticsTotalGoals.vue'
import StatisticsForm from '@/components/soccer/statistics/StatisticsForm.vue'
import StatisticsHeadtoHead from '@/components/soccer/statistics/StatisticsHeadtoHead.vue'
import StatisticsOponnents from '@/components/soccer/statistics/StatisticsOponnents.vue'

import BetPlacing from '@/components/soccer/bet-place/BetPlacing.vue'
import BetPlacingMobileHeader from '@/components/soccer/bet-place/BetPlacingMobileHeader.vue'

import SimpleTicket from '@/components/soccer/ticket/SimpleTicket.vue'
import PlayedTickets from '@/components/soccer/ticket/PlayedTickets.vue'

import ModalConnectionError from '@/components/soccer/modal/ModalConnectionError.vue'
import ModalDeviceOrientation from '@/components/soccer/modal/ModalDeviceOrientation.vue'

import LeftMenuContainer from '@/components/soccer/left-menu/LeftMenuContainer.vue'

import BettingHistory from '@/components/soccer/history/BettingHistory.vue'
import ResultLine from '@/components/soccer/result-line/ResultLine.vue'

import FloatingContent from '@/components/soccer/floating-tab/FloatingContent.vue'
import FloatingTab from '@/components/soccer/floating-tab/FloatingTab.vue'

import ConfirmScreen from '@/components/soccer/confirm/ConfirmScreen.vue'
import CountDownTimer from '@/components/common/CountDownTimer.vue'
import GamesSwitcher from '@/components/common/GameSwitcher.vue'
import Loading from '@/components/common/LoadingScreen.vue'
import GoalBlink from '@/components/common/GoalBlink.vue'
import visibility from 'vue-visibility-change'
import VueCurrencyInput from 'vue-currency-input'

Vue.component('stake-table', StakeTable)
Vue.component('goal-blink', GoalBlink)

Vue.component('one-match', OneMatch)
// Vue.component('vsoccer', VSoccerPage)
// Vue.component('grayhound', GrayhoundRaces)
Vue.component('played-tickets', PlayedTickets)

Vue.component('statistics-total-goals', StatisticsTotalGoals)
Vue.component('statistics-form', StatisticsForm)
Vue.component('statistics-headtohead', StatisticsHeadtoHead)
Vue.component('statistics-oponnents', StatisticsOponnents)

Vue.component('bet-placing', BetPlacing)
Vue.component('simple-ticket', SimpleTicket)
Vue.component('bet-placing-mobile-header', BetPlacingMobileHeader)
Vue.component('count-down-timer', CountDownTimer)
Vue.component('modal-connection-error', ModalConnectionError)

Vue.component('modal-device-orientation', ModalDeviceOrientation)
Vue.component('left-menu-container', LeftMenuContainer)
Vue.component('betting-history', BettingHistory)
Vue.component('result-line', ResultLine)
Vue.component('matches-slide', MatchesSlide)
Vue.component('floating-tab', FloatingTab)
Vue.component('floating-content', FloatingContent)

Vue.component('modal-confirm', ConfirmScreen)
Vue.component('games-switcher', GamesSwitcher)
Vue.component('loading-screen', Loading)

Vue.use(Router)
Vue.use(Vue2TouchEvents)
Vue.use(visibility)

Vue.use(VueCurrencyInput, {
  /* see config reference */
  globalOptions: { currency: 'EUR' }
})

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: 'VGames',
      component: VGamesContainer
    }
  ]
})
